import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from '@awaze/design-system.components.stack';
import { FooterPanel } from './footer-panel';
import { FAQCircle, HouseHeart, IconABTA, IconShield } from './icon';
export const FooterPanels = ({ panels }) => {
    function generatePanels() {
        return panels.map((panel, index) => {
            const button = panel.cta;
            let icon = null;
            let buttonIcon = null;
            if (panel.icon && panel.icon === 'abta') {
                icon = _jsx(IconABTA, {});
            }
            switch (button.icon) {
                case 'shield':
                    buttonIcon = _jsx(IconShield, {});
                    break;
                case 'faq':
                    buttonIcon = _jsx(FAQCircle, {});
                    break;
                case 'houseHeart':
                    buttonIcon = _jsx(HouseHeart, {});
                    break;
                default:
                    break;
            }
            return (_jsx(FooterPanel, { title: panel.title, text: panel.text, secondaryText: panel.secondaryText, icon: icon, cta: {
                    text: button.text,
                    title: button.title,
                    link: button.link ?? '',
                }, buttonIcon: buttonIcon }, index));
        });
    }
    return (_jsx(Stack, { as: "article", direction: ['column', 'row', 'row'], justify: "stretch", spacing: [0, 8, 8], equalChildren: true, children: generatePanels() }));
};
//# sourceMappingURL=footer-panels.js.map